/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'upload': {
    width: 38,
    height: 38,
    viewBox: '0 0 38 38',
    data: '<path pid="0" d="M35.596.301A1.501 1.501 0 0137.7 2.403L18.876 21.078h7.26a1.502 1.502 0 010 3.004H14.568l-.15-.1h-.1a1.533 1.533 0 01-.4-.4v-.1l-.1-.151v-.301a1.544 1.544 0 01-.051-.3V11.865a1.502 1.502 0 013.003 0v7.26L35.596.3zM6.508 38A6.508 6.508 0 010 31.492V9.813a6.508 6.508 0 016.508-6.508h13.119a1.502 1.502 0 010 3.004H6.508a3.505 3.505 0 00-3.504 3.504v21.679a3.506 3.506 0 003.504 3.504h21.679a3.505 3.505 0 003.504-3.504V18.373a1.502 1.502 0 013.004 0v13.119A6.508 6.508 0 0128.187 38H6.508z" _fill="#BEC7D4" fill-rule="evenodd"/>'
  }
})
